import { render, staticRenderFns } from "./manageStore.vue?vue&type=template&id=36e8b65a&"
import script from "./manageStore.vue?vue&type=script&lang=js&"
export * from "./manageStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports